// src/hooks/useSearchedProducts.js
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const useSearchedProducts = (products) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [filteredProducts, setFilteredProducts] = useState(products);

  useEffect(() => {
    if (location.state?.searchedProductId) {
      const filtered = products.filter(
        (p) => p._id === location.state.searchedProductId
      );
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts(products);
    }
  }, [location.state, products]);

  const resetProducts = () => {
    navigate(location.pathname, { replace: true });
    setFilteredProducts(products);
  };

  return {
    filteredProducts,
    isFiltered: !!location.state?.searchedProductId,
    resetProducts,
  };
};

export default useSearchedProducts;
